import { Component } from "react";
import RemboMark from "./RemboMark";
import Button from "./ui/Button";
import "./css/error_boundary.css";

// Top-level crash guard. A page-level fetch error should render an
// ErrorState inline; this is only for render-time exceptions that would
// otherwise blank the whole app.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="rl-crash">
        <RemboMark size={56} variant="solid" />
        <h1 className="rl-crash-title">Something went wrong</h1>
        <p className="rl-crash-text">
          RemboList hit an unexpected error. Reloading usually fixes it.
        </p>
        <Button onClick={this.handleRetry}>Reload the page</Button>
      </div>
    );
  }
}
